import { useSortedSmartLists } from 'features/smart-lists';
import React from 'react';
import { Check, IconFormIcons, IconFormNames } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import {
  PopupMenu,
  PopupMenuButton,
  PopupMenuList,
  PopupMenuListItem,
} from 'shared/components/ui/popup-menu';
import { ID } from 'shared/types/id';

import * as Styled from './select-smart-lists-context-menu.style';

export type SelectSmartListsContextMenuProps = Omit<
  React.ComponentProps<typeof PopupMenu>,
  'onOutside' | 'position' | 'children'
> & {
  onSmartList: (id: ID) => void;
  activeSmartLists?: ID[];
  onClose: () => void;
};

// Acceptable parallel of SelectTagsContextMenu (reuse-over-reinvent.md): same
// picker shape, but smart-lists render a dynamic icon with a fallback (vs a
// static tag glyph) and carry a nullable color — a different render contract.
export const SelectSmartListsContextMenu: React.FC<
  SelectSmartListsContextMenuProps
> = ({ onClose, onSmartList, activeSmartLists = [], ...popupMenuProps }) => {
  const smartLists = useSortedSmartLists();

  return (
    <PopupMenu {...popupMenuProps} onOutside={onClose} position="bottom-end">
      <PopupMenuList>
        {smartLists.map(({ id, name, color, icon }) => {
          const onSelect = () => onSmartList(id);

          return (
            <PopupMenuListItem key={id}>
              <PopupMenuButton
                start={
                  <Styled.IconContainer $color={color ?? undefined}>
                    <Icon
                      icon={IconFormIcons[icon || IconFormNames.SmartList]}
                    />
                  </Styled.IconContainer>
                }
                end={
                  activeSmartLists.includes(id) ? (
                    <Styled.CheckIconContainer>
                      <Icon icon={Check} />
                    </Styled.CheckIconContainer>
                  ) : undefined
                }
                onClick={onSelect}
              >
                {name}
              </PopupMenuButton>
            </PopupMenuListItem>
          );
        })}
      </PopupMenuList>
    </PopupMenu>
  );
};
